<div class="main-container centered" @fadeIn>
	<p><strong>Thank you for using Vitralogy Binder</strong></p>
	<p class="secondary">This link is expired.</p>
	<p class="secondary">If you need another link, please scan the QR code again.</p>
</div>